import React from "react";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";

export default function RepeatableListField({label, values, onChange, placeholder, error, translate}) {
    const items = values?.length ? values : [""];

    const update = (index, value) => {
        onChange(items.map((item, itemIndex) => itemIndex === index ? value : item));
    };

    const remove = (index) => {
        onChange(items.filter((_, itemIndex) => itemIndex !== index));
    };

    const move = (index, direction) => {
        const next = [...items];
        const target = index + direction;
        if (target < 0 || target >= next.length) return;
        [next[index], next[target]] = [next[target], next[index]];
        onChange(next);
    };

    return (
        <div className="pbb-field-group">
            <label>{label}</label>
            <div className="pbb-repeatable">
                {items.map((item, index) => (
                    <div className="pbb-repeatable-row" key={index}>
                        <InputText value={item} onChange={(event) => update(index, event.target.value)} placeholder={placeholder}/>
                        <Button type="button" icon="pi pi-arrow-up" text rounded disabled={index === 0} onClick={() => move(index, -1)} tooltip={translate("pbb-move-up")}/>
                        <Button type="button" icon="pi pi-arrow-down" text rounded disabled={index === items.length - 1} onClick={() => move(index, 1)} tooltip={translate("pbb-move-down")}/>
                        <Button type="button" icon="pi pi-trash" text rounded severity="danger" disabled={items.length === 1} onClick={() => remove(index)} tooltip={translate("delete")}/>
                    </div>
                ))}
            </div>
            {error && <small className="p-error">{translate(error)}</small>}
            <Button type="button" icon="pi pi-plus" label={translate("pbb-add-item")} outlined className="w-fit" onClick={() => onChange([...items, ""])}/>
        </div>
    );
}
